export default "__VITE_ASSET__CIsCjhUV__"